module.exports = __webpack_public_path__ + "static/media/Spa-Signature.4b6305ad.png";